import axios from 'axios'

// GA4 일반상품 태그 인터페이스
const ga4_getViewItemListObj = (item_name, item_id, price, item_brand, item_category, item_category2, item_category3, item_category4, item_category5, item_variant, item_list_name, quantity) => {
    const obj = {
        item_name: item_name,
        item_id: item_id,
        price: price,
        item_brand: item_brand,
        item_category: item_category,
        item_category2: item_category2,
        item_category3: item_category3,
        item_category4: item_category4,
        item_category5: item_category5,
        item_variant: item_variant,
        item_list_name: item_list_name,
        quantity: quantity
    }
    return obj
}

// UA 일반상품 태그 인터페이스
// const ua_getViewItemListObj = (item_name, item_id, price, brand, category, variant, list) => {
//     const obj = {
//         name: item_name,
//         id: item_id,
//         price: price,
//         brand: brand,
//         category: category,
//         variant: variant,
//         list: list
//     }
//     return obj
// }

// GA4 광고 태그 인터페이스
const ga4TagInterface = (item_name, item_id, promotion_id, promotion_name, creative_name, location_id) => {
    const obj = {
        item_name: item_name,
        item_id: item_id,
        promotion_id: promotion_id,
        promotion_name: promotion_name,
        creative_name: creative_name,
        location_id: location_id
    }
    return obj
}

// UA 광고 태그 인터페이스
// const uaTagInterface = (id, name, creative, position) => {
//     const obj = {
//         id: id,
//         name: name,
//         creative: creative,
//         position: position
//     }
//     return obj
// }


// GA4 태그 Push
const ga4Push = (eventName, itemData) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: eventName,
        ecommerce: {
            items: itemData
        }
    });
}

// UA 노출 태그 Push
// const uaPush = (obj) => {
//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'promotionImpression',
//         'ecommerce': {
//             'promoView': {
//                 'promotions': obj
//             }
//         }
//     });
// }

// UA 클릭 태그 Push
// function uaClickPush(obj) {
//     window.dataLayer = window.dataLayer || [];
//     window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'promotionClick',
//         'ecommerce': {
//             'promoClick': {
//                 'promotions': obj
//             }
//         },
//         'eventCallback': function () {
//         }
//     });
// }


// 2021-12-21 SYC : 큐레이션 광고 노출 태그
export const ga4AdView = (adInfo) => {

    // Yotube banner 생성
    const bannerArray = [0]
    let banner = bannerArray.map(function () {
        return ga4TagInterface(
            null,
            null,
            adInfo.mall_name + '_' + adInfo.idx_b_manager,
            adInfo.nm_ad,
            adInfo.ad_id,
            `${adInfo.cat_id}_ null`
        )
    })

    if (adInfo.items.length > 0) {
        const items = adInfo.items.map((v) => {
            return ga4TagInterface(
                null,
                null,
                adInfo.mall_name + '_' + adInfo.idx_b_manager,
                adInfo.nm_ad,
                adInfo.ad_id,
                adInfo.cat_id + '_' + v.item_id
            )
        })

        banner = banner.concat(items)
    }
    ga4Push("view_promotion", banner)
}

// 2021-12-21 SYC : 큐레이션 광고 클릭 태그
export const ga4AdClick = ({ item, adinfo }) => {
    const ga4_item = [
        ga4TagInterface(
            null,
            null,
            adinfo.id,
            adinfo.name,
            adinfo.creative,
            adinfo.cate_id + '_' + item.item_id
        ),
    ]
    ga4Push("select_promotion", ga4_item)
}

// 2021-12-21 SYC : 큐레이션 광고 노출 태그
// export const uaAdView = (adInfo) => {
//
//     // Yotube banner 생성
//     const bannerArray = [0]
//     let banner = bannerArray.map(function () {
//         return uaTagInterface(
//             adInfo.mall_name + '_' + adInfo.idx_b_manager,
//             adInfo.nm_ad,
//             adInfo.ad_id,
//             `${adInfo.cat_id}_ null`
//         )
//     })
//
//     if (adInfo.items.length > 0) {
//         const items = adInfo.items.map((v) => {
//             return uaTagInterface(
//                 adInfo.mall_name + '_' + adInfo.idx_b_manager,
//                 adInfo.nm_ad,
//                 adInfo.ad_id,
//                 adInfo.cat_id + '_' + v.item_id
//             )
//         })
//         banner = banner.concat(items)
//     }
//     uaPush(banner)
// }

// 2021-12-21 SYC : 큐레이션 광고 클릭 태그
// export const uaAdClick = ({ item, adinfo }) => {
//
//     window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'promotionClick',
//         'ecommerce': {
//             'promoClick': {
//                 'promotions': [
//                     {
//                         'id': adinfo.id,
//                         'name': adinfo.name,
//                         'creative': adinfo.creative,
//                         'position': adinfo.cate_id + '_' + item.item_id
//                     }
//                 ]
//             }
//         },
//         'eventCallback': function () {
//         }
//     });
//
//     const ua_AdItem = [
//         uaTagInterface(
//             adinfo.id,
//             adinfo.name,
//             adinfo.creative,
//             adinfo.cate_id + '_' + item.item_id
//         ),
//     ]
//     uaClickPush(ua_AdItem);
// }


// 2021-12-15 SYC : GA4 일반상품 광고 노출 태그 삽입
export const ga4_AdView = ({ lists }) => {

    const ga4_itemList = lists.items.map((v) => {
        return ga4TagInterface(
            null,
            null,
            v.mall_name + '_' + v.ad_idx_b_manager,
            lists.ad.nm_ad,
            v.ad_id,
            v.select_cate + '_' + v.item_id
        )
    })
    ga4Push("view_promotion", ga4_itemList)
}

// 2021-12-15 SYC : GA4 일반상품 광고 클릭 태그 삽입
export const ga4_AdClick = (obj) => {
    const ga4_item = [
        ga4TagInterface(
            null,
            null,
            obj.item.mall_name + '_' + obj.item.ad_idx_b_manager,
            obj.item.nm_ad,
            obj.item.ad_id,
            obj.item.select_cate + '_' + obj.item.item_id
        ),
    ]
    ga4Push("select_promotion", ga4_item)
}

// 일반상품 광고 노출 태그
// export const ua_AdView = ({ lists }) => {
//     const uaItemList = lists.items.map((v, i) => {
//         return uaTagInterface(
//             v.mall_name + '_' + v.ad_idx_b_manager,
//             lists.ad.nm_ad,
//             v.ad_id,
//             v.select_cate + '_' + v.item_id
//         )
//     })
//     uaPush(uaItemList)
// }

// 일반상품 광고 클릭 태그
// export const ua_AdClick = (obj) => {
//     window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'promotionClick',
//         'ecommerce': {
//             'promoClick': {
//                 'promotions': [
//                     {
//                         id: obj.item.mall_name + '_' + obj.item.ad_idx_b_manager,
//                         name: obj.item.nm_ad,
//                         creative: obj.item.ad_id,
//                         position: obj.item.select_cate + '_' + obj.item.item_id,
//                     }
//                 ]
//             }
//         },
//         'eventCallback': function () {
//         }
//     });
//
//     const ua_AdItem = [
//         uaTagInterface(
//             obj.item.mall_name + '_' + obj.item.ad_idx_b_manager,
//             obj.item.nm_ad,
//             obj.item.ad_id,
//             obj.item.select_cate + '_' + obj.item.item_id
//         ),
//     ]
//     uaClickPush(ua_AdItem);
// }

export const ga4_viewItemList = ({ lists, list_name }) => {
    const ga4_itemList = lists.map((v, _) => {
        const item_category = v.category.map((cv) => {
            return cv.cate_name
        })
        return ga4_getViewItemListObj(
            v.item_name,
            v.item_id,
            v.price_low_cash,
            v.maker_name,
            (item_category[0] ? item_category[0] : ''),
            (item_category[1] ? item_category[1] : ''),
            (item_category[2] ? item_category[2] : ''),
            (item_category[3] ? item_category[3] : ''),
            (item_category[4] ? item_category[4] : ''),
            '',
            list_name,
            1
        )
    })
    ga4Push("view_item_list", ga4_itemList)
}

// 일반상품 클릭 태그
export const ga4_clickItem = ({ item, tag_item, list_name }) => {

    const item_category = tag_item.real_catename.map((cv) => {
        return cv.cate_name
    })

    const ga4_item = [
        ga4_getViewItemListObj(
            item.item_name,
            item.item_id,
            item.price_low_cash,
            item.maker_name,
            (item_category[0] ? item_category[0] : ''),
            (item_category[1] ? item_category[1] : ''),
            (item_category[2] ? item_category[2] : ''),
            (item_category[3] ? item_category[3] : ''),
            (item_category[4] ? item_category[4] : ''),
            '',
            list_name,
            1,
        ),
    ]
    // console.log(ga4_item);
    ga4Push("select_item", ga4_item)

}

// 일반상품 노출 태그 : 사용 X
// export const ua_viewItemList = ({ lists, list_name }) => {
//     const ua_itemList = lists.map((v) => {
//         const ua_cateName = v.category.map((cv) => {
//             return cv.cate_name
//         })
//         return ua_getViewItemListObj(
//             v.item_name,
//             v.item_id,
//             v.price_low_cash,
//             v.maker_name,
//             ua_cateName.join(' / '),
//             '',
//             list_name
//         )
//     })
//     window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'productDetailImpression',
//         'ecommerce': {
//             'currencyCode': 'KRW',
//             'impressions': ua_itemList
//         }
//     });
// }

// 일반상품 클릭 태그
// export const ua_clickItem = ({ item, tag_item, list_name }) => {
//
//     const ua_cateName = tag_item.real_catename.map((cv) => {
//         return cv.cate_name
//     })
//     window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'productClick',
//         'ecommerce': {
//             'click': {
//                 'actionField': { 'list': list_name },
//                 'products': [{
//                     'name': item.item_name,
//                     'id': item.item_id,
//                     'price': item.price_low_cash,
//                     'brand': item.maker_name,
//                     'category': ua_cateName.join(' / '),
//                     'variant': ''
//                 }]
//             }
//         },
//         'eventCallback': function () {
//             document.location = productObj.url
//         }
//     });
//     console.log(window.dataLayer);
// }


export const page_view = () => {
    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        'event': 'Pageview',
        'pagePath': window.location.pathname,
        'pageTitle': ''
    });
    window.dataLayer = window.dataLayer || [];
    // window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        'event': 'virtualPageview',
        'pageUrl': window.location.href,
        'pageTitle': ''
    });
}

// const uaAddCart = (products) => {
//     // window.dataLayer.push({ ecommerce: null });
//     window.dataLayer.push({
//         'event': 'addToCart',
//         'ecommerce': {
//             'currencyCode': 'KRW',
//             'add': {
//                 'products': products
//             }
//         }
//     });
// }

const ga4AddCart = (items) => {
    // window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            items: items
        }
    });
}

export const gaAddCartItemProcess = (lists, addItemList) => {
    const products = []
    const items = []
    lists.map((item, i) => {
        const products_cateName = item.category.map((v) => {
            return v.cate_name
        })
        products.push({
            name: item.itemNameOrg,
            id: item.itemID,
            price: item.price,
            brand: item.makerName,
            category: products_cateName.join(' / '),
            variant: '',
            quantity: addItemList[i].count,
            coupon: ''
        })

        items.push({
            item_name: item.itemNameOrg,
            item_id: item.itemID,
            price: item.price,
            item_brand: item.makerName,
            item_category: (products_cateName[0]) ? products_cateName[0] : '',
            item_category2: (products_cateName[1]) ? products_cateName[1] : '',
            item_category3: (products_cateName[2]) ? products_cateName[2] : '',
            item_category4: (products_cateName[3]) ? products_cateName[3] : '',
            item_category5: (products_cateName[4]) ? products_cateName[4] : '',
            item_variant: '',
            coupon: '',
            quantity: addItemList[i].count,
        })
        return false
    })

    // uaAddCart(products)
    ga4AddCart(items)
}

export const ga4API2 = (adv,categoryId) => {
    axios(process.env.REACT_APP_API2_URL+`/ga4/v1/ads/${adv}/view/${categoryId}`).then(res => {
        if (!window.dataLayer) {
            window.dataLayer = []; // dataLayer 초기화
        }
        window.dataLayer.push(res.data);
    });
}
export const ga4ClickAPI2 = (adv,itemId) => {
    axios(process.env.REACT_APP_API2_URL+`/ga4/v1/ads/${adv}/click/${itemId}`).then(res =>{
        if (!window.dataLayer) {
            window.dataLayer = []; // dataLayer 초기화
        }
        window.dataLayer.push(res.data);
    })
}



// WEBPACK FOOTER //
// ./src/estimate_list/libs/googleTagmanager.js